import { render, staticRenderFns } from "./SimpleLabelSelector.vue?vue&type=template&id=283f1fa0&"
import script from "./SimpleLabelSelector.vue?vue&type=script&lang=js&"
export * from "./SimpleLabelSelector.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLabelSelector.vue?vue&type=style&index=0&id=283f1fa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports